
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import BackofficeLayout from "@/components/layouts/BackofficeLayout";
import { Button } from "@/components/ui/button";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { ChevronLeft } from "lucide-react";
import DocumentTypeForm from "@/components/documents/DocumentTypeForm";
import { useToast } from "@/hooks/use-toast";

const DocumentTypeCreate = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  // "?mc=<id>": creating from a management company's own page pre-sets the
  // scope to that company (8-Sep).
  const [searchParams] = useSearchParams();
  const mcParam = searchParams.get("mc");

  const handleSuccess = () => {
    toast({
      title: "Document type created",
      description: "The document type has been created successfully.",
    });
    navigate("/backoffice/settings?tab=document-types");
  };

  const handleCancel = () => {
    navigate("/backoffice/settings?tab=document-types");
  };

  return (
    <BackofficeLayout>
      <div className="space-y-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="space-y-1">
            <Button asChild variant="outline" size="sm">
              <Link to="/backoffice/settings?tab=document-types">
                <ChevronLeft className="mr-1 h-4 w-4" />
                Back to Document Types
              </Link>
            </Button>
            <h1 className="text-3xl font-bold tracking-tight">Create New Document Type</h1>
            <p className="text-gray-500">
              Add a new document type to the system
            </p>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Document Type Information</CardTitle>
            <CardDescription>
              Enter the document type details
            </CardDescription>
          </CardHeader>
          <CardContent>
            <DocumentTypeForm
              onSuccess={handleSuccess}
              onCancel={handleCancel}
              defaultManagementCompanyId={mcParam ? Number(mcParam) : undefined}
            />
          </CardContent>
        </Card>
      </div>
    </BackofficeLayout>
  );
};

export default DocumentTypeCreate;
